<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="8" width="4" height="20" rx="2" fill="white" />
		<rect
			x="20"
			y="8"
			width="4"
			height="20"
			rx="2"
			transform="rotate(90 20 8)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "PlusIcon",
};
</script>
